<template>
  <el-dialog
    title="选择活动"
    center
    top="5vh"
    :visible.sync="isShowDialog"
    append-to-body
    width="90%"
    :before-close="beforeclose"
  >
    <el-form
      :inline="true"
      ref="searchform"
      :model="formData"
      class="demo-form-inline"
      size="medium"
    >
      <el-form-item label="活动ID">
        <el-input
          type="number"
          v-model="formData.id"
          placeholder="请输入活动ID号"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="活动名称">
        <el-input
          type="text"
          v-model="formData.name"
          placeholder="请输入活动名称"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select
          v-model="formData.activityStatus"
          placeholder="全部状态"
          clearable
        >
          <el-option label="正在进行" :value="22"></el-option>
          <el-option label="未开始" :value="21"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始时间">
        <el-date-picker
          key="data1"
          clearable
          v-model="formData.beginTime"
          type="datetimerange"
          start-placeholder="开始时间"
          range-separator="至"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结束时间">
        <el-date-picker
          key="data2"
          clearable
          v-model="formData.endTime"
          type="datetimerange"
          start-placeholder="开始时间"
          range-separator="至"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="商品名称">
        <el-input
          type="text"
          v-model="formData.productName"
          placeholder="请输入商品名称"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="商品编号">
        <el-input
          type="text"
          v-model="formData.productIdList"
          placeholder="多个商品ID,用英文逗号隔开"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="活动平台">
        <el-select v-model="formData.platforms" placeholder="全部" clearable>
          <el-option label="APP" value="APP"></el-option>
          <el-option label="小程序" value="MINI_APP"></el-option>
        </el-select>
      </el-form-item>
      <span style="margin-left: 20px">
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="resetForm('searchform')">重置</el-button>
      </span>
    </el-form>
    <div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        @select="changeFun"
        @selection-change="handleSelectionChange"
        ref="multipleTable"
        row-key="productId"
        class="table"
      >
        <el-table-column
          type="selection"
          width="55"
          :selectable="selected"
          reserve-selection
          align="center"
        ></el-table-column>
        <el-table-column
          prop="id"
          label="活动ID"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="name"
          width="200"
          label="活动名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="beginTime"
          width="100"
          label="场次"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.beginTime">{{
              scope.row.beginTime.split(" ")[1].substr(0, 5)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="beginTime"
          width="200"
          label="开始时间"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="endTime"
          width="200"
          label="结束时间"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="platforms"
          label="活动平台"
          align="center"
        ></el-table-column>

        <el-table-column label="状态" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.activityStatus == 20">待开启</el-tag>
            <el-tag v-if="scope.row.activityStatus == 22">正在进行</el-tag>
            <el-tag v-if="scope.row.activityStatus == 3">已暂停</el-tag>
            <el-tag v-if="scope.row.activityStatus == 21">未开始</el-tag>
            <el-tag v-if="scope.row.activityStatus == 4">已结束</el-tag>
            <el-tag v-if="scope.row.activityStatus == 5">已过期</el-tag>
          </template>
        </el-table-column>

        <el-table-column
          prop="productCount"
          width="100"
          label="商品数量"
          align="center"
        ></el-table-column>
      </el-table>
    </div>
    <div class="coupon-clock-paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formData.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="formData.pageSize"
        layout="total,sizes, prev, pager, next, jumper"
        :total="total"
        background
      ></el-pagination>
    </div>
    <el-row type="flex" justify="center" style="margin-top: 30px">
      <el-button @click="beforeclose">取消</el-button>
      <el-button type="primary" @click="saveData" :loading="saveLoading"
        >确定</el-button
      >
    </el-row>
  </el-dialog>
</template>

<script>
import {
  querySeckillActivityList,
  querySeckillActivityDetail
} from "@/api/shop/selfpromotionManage";
import { getSpreadActivityProductList } from "@/api/shop/activitySet";
export default {
  props: ["isShowDialog"],
  inject: ["control"],
  data() {
    return {
      saveLoading: false,
      formData: {
        platforms: "",
        activityStatus: "",
        activityType: 20, //活动类型
        channelCode: "SHOP",
        id: "", //活动id
        name: "", //活动名称
        activityStatusList: [21, 22], //活动状态
        beginTime: [], // 开始时间${moment().format('YYYY-MM-DD HH:mm:ss')}
        endTime: [], // 结束时间
        productIdList: "", // 产品id
        productName: "", //商品名称
        page: 1, //当前页
        pageSize: 10 //页面数量
      },
      loading: false,
      channelSelects: [], // 渠道数据

      tableData: [], //表单数据
      total: 0, //总条数
      selectionData: [], //选中数据
      selectedIds: []
    };
  },
  watch: {
    isShowDialog: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.getData();
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    uniqueById(array, property) {
      return array.filter(
        (obj, index, self) =>
          index === self.findIndex(o => o[property] === obj[property])
      );
    },
    verify(id) {
      const { components } = this.control;
      const seckillComponents = components.filter(
        item => item.component === "Seckill"
      );
      if (
        seckillComponents.some(
          item => item.activityInfos.length && item.activityInfos[0].id === id
        )
      ) {
        return true;
      }
      return false;
    },
    getData() {
      this.loading = true;
      const data = {
        ...this.formData,
        beginTimeStart: this.formData.beginTime
          ? this.formData.beginTime[0]
          : "",
        beginTimeEnd: this.formData.beginTime ? this.formData.beginTime[1] : "",
        endTimeStart: this.formData.endTime ? this.formData.endTime[0] : "",
        endTimeEnd: this.formData.endTime ? this.formData.endTime[1] : ""
      };
      if (data.productIdList && data.productIdList.includes(",")) {
        data.productIdList = data.productIdList.split(",");
      }
      if (data.activityStatus) {
        delete data.activityStatusList;
      }
      querySeckillActivityList(data)
        .then(res => {
          this.loading = false;
          if (res.code == 200) {
            this.tableData = res.data.rows;
            this.total = res.data.count;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    search() {
      this.formData.page = 1;
      this.getData();
    },
    selected(row, index) {
      if (this.selectedIds.indexOf(row.productId) >= 0) {
        return false;
      } else {
        return true;
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.getData();
    },

    //修改每页数量
    handleSizeChange(val) {
      this.formData.pageSize = val;
      this.formData.page = 1;
      this.getData();
    },
    handleSelectionChange(val) {
      this.selectionData = val;
    },

    handleGoodsData(params) {
      // 这里直接参考小程序的逻辑，因不支持 a?.b?.c 这种语法, 改用三目
      const activityBgStyle = params
        ? params.activityInfo
          ? params.activityInfo.activityBgStyle
            ? JSON.parse(params.activityInfo.activityBgStyle)
            : undefined
          : undefined
        : null;

      const showStart = params
        ? params.activityInfo
          ? params.activityInfo.showStartPositions
            ? params.activityInfo.showStartPositions.includes("4")
            : undefined
          : undefined
        : undefined;

      const showEnd = params
        ? params.activityInfo
          ? params.activityInfo.showEndPositions
            ? params.activityInfo.showEndPositions.includes("4")
            : undefined
          : undefined
        : undefined;

      const showJiaoBiao = params
        ? params.activityInfo
          ? params.activityInfo.styleShowPositions
            ? params.activityInfo.styleShowPositions.includes("2")
            : undefined
          : undefined
        : undefined;

      return {
        ...params,
        activityInfo: {
          ...params.activityInfo,
          activityBgStyle,
          // 4 就是搜索 活动页  时间 展示开始 和 结束
          showStart,
          showEnd,
          // 2 就是 搜索活动页面 角标 是否展示
          showJiaoBiao
        }
      };
    },
    async saveData() {
      const { selectionData } = this;
      if (selectionData.length == 1) {
        if (this.verify(selectionData[0].id)) {
          return this.$message.warning("该活动已存在");
        }
        this.saveLoading = true;
        const { id } = selectionData[0];
        const { data } = await querySeckillActivityDetail({ id });
        const productIds = data.activityProductList.map(item => {
          return item.productId;
        });
        const params = await this.getSpreadActivityProductList(productIds);
        const handleParams = params.map(item => {
          return this.handleGoodsData(item);
        });
        this.saveLoading = false;
        this.$emit("selected", {
          activity: selectionData[0],
          list: handleParams
        });
        this.$emit("closeShowDialog", false);
      } else {
        this.$message.warning("请添加一场活动");
      }
    },
    async getSpreadActivityProductList(ids) {
      try {
        const { data, code, mes } = await getSpreadActivityProductList(ids);
        if (code === 200) {
          return Promise.resolve(data);
        } else {
          return Promise.reject(mes);
        }
      } catch (_) {
        return Promise.reject("请求异常");
      }
    },
    resetForm() {
      this.formData.page = 1;
      this.formData = Object.assign(this.formData, {
        channelCode: "SHOP",
        platforms: "",
        id: "", //活动id
        name: "", //活动名称
        activityStatus: "", //活动状态
        beginTime: "", // 开始时间${moment().format('YYYY-MM-DD HH:mm:ss')}
        endTime: "", // 结束时间
        productIdList: "", // 产品id
        productName: "", //商品名称
        page: 1,
        pageSize: 10
      });
      this.getData();
    },
    //切换页面
    handleCurrentChange(val) {
      this.formData.page = val;
      this.getData();
    },
    beforeclose() {
      this.$emit("closeShowDialog", false);
    },
    changeFun(selection) {
      if (selection.length > 1) {
        const del_row = selection.shift();
        this.$refs.multipleTable.toggleRowSelection(del_row, false);
      }
      this.checkList = selection[0];
    }
  }
};
</script>

<style scoped lang="less">
.coupon-clock-paging {
  width: 100%;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}
.table {
  /deep/ .el-table__header-wrapper {
    > .el-table__header {
      > .has-gutter {
        .el-checkbox {
          display: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/components/SelectSeckillActivity.vue